import { useEffect } from 'react';

interface UseCurrentTimeLineEffectsProps {
  isToday: boolean;
  updateTimeHandler: () => void;
}

export const useCurrentTimeLineEffects = ({
  isToday,
  updateTimeHandler,
}: UseCurrentTimeLineEffectsProps) => {
  useEffect(() => {
    if (!isToday) {
      return;
    }

    const intervalId = setInterval(updateTimeHandler, 60_000);

    return () => {
      clearInterval(intervalId);
    };
  }, [isToday, updateTimeHandler]);
};
